import createLabelValueOption from 'App/utils/createLabelValueOption';

const specialQuestions = [
    'assessment_status',
    'need_by_date',
    'therapy_start_date',
    'activity_date',
    'cost_savings',
    'therapy_summary_note',
];

const noGroupOption = { id: null, group_order: -1, name: 'No Group' };

const numericRiskTypeOptions = [
    { value: 'enteredValue', label: 'Use Entered Value' },
    { value: 'ranges', label: 'Create Ranges' },
];

const readLinkOption = createLabelValueOption('Read Link');
const writeLinkOption = createLabelValueOption('Write Link');
const readWriteLinkOption = createLabelValueOption('Read & Write Link');
const profileOption = createLabelValueOption('Profile');

export {
    specialQuestions,
    noGroupOption,
    numericRiskTypeOptions,
    readLinkOption,
    writeLinkOption,
    readWriteLinkOption,
    profileOption,
};
